import * as React from "react";
import { HandleRedirectPaymentChallenge as PRHandleRedirectPaymentChallenge, IElementFactory } from "@cspayments/pidl-react";
import { FluentUIElementFactory } from "@cspayments/pidl-fluent-ui";
import { useState } from "react";
import "./HandleRedirectPaymentChallenge.css";
import { LocResources } from "./locResources";
import Helper from "./Helper";

const locResources: LocResources = new LocResources(Helper.getLanguageParam());

interface IHandleRedirectPaymentChallengeProps {
    sessionId: string;
    env: string;
}

const HandleRedirectPaymentChallenge = (props: IHandleRedirectPaymentChallengeProps) => {
    const [message, setMessage] = useState("");
    const fluentUi: IElementFactory =  new FluentUIElementFactory();

    const failureHandler = (params: any) => {
        const message = params?.userDisplayMessage || locResources.getByName("FailureHandlerError");
        setMessage(message);
    }

    const successHandler = (params: any) => {
        const message = params?.userDisplayMessage || locResources.getByName("SuccessHandlerError");
        setMessage(message);
    }

    const cancelHandler = (params: any) => {
        const message = params?.userDisplayMessage || locResources.getByName("CancelHandlerError");
        setMessage(message);
    }

    const redirectPaymentChallengeProps: any = {
        elementFactory: fluentUi,
        env: props.env,
        sessionId: props.sessionId,
        returnOptions: {
            urls: {
                success: window.location.origin,
                failure: window.location.origin,
                gohome: window.location.origin,
            },
            callbacks: {
                failure: failureHandler,
                success: successHandler,
                gohome: cancelHandler,
            }
        },
        userContext: {},
        displayOptions: {
            containerId: "pidl-react-container"
        }
    }

    return (
        <div className="challenge-container">
            <h1>{locResources.getByName("AuthenticatePurchaseHeader")}</h1>
            <h4>{locResources.getByName("AuthenticatePurchaseInstructions")}</h4>
            {message && <div className="challenge-message">{message}</div>}
            <PRHandleRedirectPaymentChallenge
                { ...redirectPaymentChallengeProps }
            />
        </div>
    );
}

export default HandleRedirectPaymentChallenge;